import React from 'react';

export const LandsbankinnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1.506 4.101 25.518 24.9"
      width="25.518"
      height="24.9"
    >
      <g fill="#163e63" transform="matrix(1, 0, 0, 1, 1.506219, 4.001299)">
        <path d="M23.3 25c1.9 0 2.5-1.4 2.1-2.6-.5-1.4-4-11.8-4-11.8s-3.7 11-4.1 12.5c-.7 2.3-3.9 1.4-3.2-1.1.7-2.5 5.3-16.7 5.8-18.4.7-2.3 1.8-3.4 4.1-3.5H12.8c-2 0-3.3 1.4-3.8 3S3.5 20.3 3 21.8c-.6 1.7-1.8 2.8-3 3.2h23.3" />
      </g>
    </svg>
  );
};
